import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MenuPopOver } from './menu-pop-over';

@NgModule({
  declarations: [MenuPopOver],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    IonicModule,
  ],
  entryComponents: [MenuPopOver],
})
export class MenuPopOverModule { }
